import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';


const BoardDropdown = ({ boards, selectedBoardId, setSelectedBoardId }) => {
  return (
    <>
    {/*<Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'white',
            mb: 4,
            borderRadius: 2,
            p: 2,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: '#1976d2',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
           
          </Typography>*/}

    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id="board-select-label">Select Board</InputLabel>
      <Select
        labelId="board-select-label"
        value={selectedBoardId}
        onChange={(e) => setSelectedBoardId(e.target.value)}
      >
        <MenuItem value="ALL_BOARDS">All Boards</MenuItem>
        {boards.map((board) => (
          <MenuItem key={board.id} value={board.id}>
            {board.boardName.length > 15 ? board.boardName.substring(0, 15) + '...' : board.boardName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
   {/*</Box>*/}
   </>
  );
};

export default BoardDropdown;
